import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=1fe020f8&scoped=true"
import script from "./NoticeList.vue?vue&type=script&lang=js"
export * from "./NoticeList.vue?vue&type=script&lang=js"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=1fe020f8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe020f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe020f8')) {
      api.createRecord('1fe020f8', component.options)
    } else {
      api.reload('1fe020f8', component.options)
    }
    module.hot.accept("./NoticeList.vue?vue&type=template&id=1fe020f8&scoped=true", function () {
      api.rerender('1fe020f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/store/NoticeList.vue"
export default component.exports